import { render, staticRenderFns } from "./RestaurantTabView.vue?vue&type=template&id=6f8943bd&scoped=true"
import script from "./RestaurantTabView.vue?vue&type=script&lang=js"
export * from "./RestaurantTabView.vue?vue&type=script&lang=js"
import style0 from "./RestaurantTabView.vue?vue&type=style&index=0&id=6f8943bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8943bd",
  null
  
)

export default component.exports